import React from "react";
import { doctor, glance } from "../mock";
import Reveal from "./Reveal";

const AtAGlance = () => {
  return (
    <section id="glance" className="bg-cream">
      <div className="max-w-6xl mx-auto px-4 py-16 lg:py-20">
        <Reveal className="text-center mb-12">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold">At a Glance</span>
          <h2 className="font-head text-3xl sm:text-4xl uppercase tracking-wide text-navy mt-2">{doctor.name}</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mt-4" />
        </Reveal>

        <Reveal className="bg-white rounded-2xl shadow-sm border border-black/5 divide-y divide-black/5 overflow-hidden">
          {glance.map((g, i) => (
            <div key={g.label} className="grid sm:grid-cols-3 gap-2 px-6 sm:px-8 py-5">
              <div className="text-xs font-bold tracking-widest uppercase text-gold sm:col-span-1 flex items-center">{g.label}</div>
              <div className="sm:col-span-2 text-navy font-medium">{g.value}</div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default AtAGlance;
